import { tm } from '../tm'
import i18n from './i18n'
import type { CSSProperties } from 'react'
import type { Locales, Project } from '@captaincause/types'

interface ProjectLabelsProps {
  project: Project
  className?: string
  style?: CSSProperties
  locale: Locales
}

const emptyObject = {}
export function ProjectLabels({
  project,
  className = '',
  style = emptyObject,
  locale,
}: ProjectLabelsProps) {
  if (!project.labels || project.labels.length === 0) return null

  const t = i18n[locale] ?? i18n.fr

  return (
    <div className={tm(className)} style={style}>
      <div className="mb-4 text-dark-gray">{t.title}</div>
      <div className="flex flex-wrap gap-10">
        {project.labels.map(label =>
          label.logo ? (
            <img
              key={label.name}
              src={label.logo}
              alt={`${label.name} label`}
              width={120}
              height={120}
              className="h-16 w-auto"
              loading="lazy"
            />
          ) : null,
        )}
      </div>
    </div>
  )
}
